export { default } from './StylovyzeTabs';
export * from './StylovyzeTabs';
